<div class="cart-item-list">
  @if (hasHeader) {
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <div class="cx-item-list-header row px-0">
        <div class="cx-item-list-desc col-md-3 col-lg-3">
          <!-- {{ 'cartItems.description' | cxTranslate }} -->
        </div>
        <div class="cx-item-list-price col-md-2 col-lg-2">
          <!-- {{ 'cartItems.itemPrice' | cxTranslate }} -->
        </div>
        <div class="cx-item-list-qty col-md-2 col-lg-2 text-md-center">
          <!-- {{ 'cartItems.quantity' | cxTranslate }} -->
        </div>
        <div class="cx-item-list-qty col-md-2 col-lg-2 text-lg-left">
          <!-- {{ 'orderHistory.ETA' | cxTranslate }} -->
        </div>
        <div class="cx-item-list-qty col-md-2 col-lg-2 text-lg-left">
          <!-- {{ 'orderHistory.status' | cxTranslate }} -->
        </div>
        @if (options.isSaveForLater) {
          <div class="cx-item-list-total col-md-1 col-lg-1">
            <!-- {{ 'saveForLaterItems.stock' | cxTranslate }} -->
          </div>
        } @else {
          <div class="cx-item-list-total col-md-1 col-lg-1">
            {{ 'cartItems.total' | cxTranslate }}
          </div>
        }
      </div>
    </div>
  }

  @for (item of items; track item; let i = $index) {
    <div class="cx-item-list-row">
      @if (getControl(item) | async; as control) {
        <div
          class="cx-item-list-items no-padding"
          [class.is-changed]="control.get('quantity').dirty"
          >
          <app-custom-cart-item
            [item]="item"
            [quantityControl]="control.get('quantity')"
            [readonly]="readonly"
            [promotionLocation]="promotionLocation"
            [options]="options"
            [maxQuantity]="setMaxQuantity(item.product)"
            [hasStock]="setHasStock(item.product)"
            (itemRemoved)="onItemRemoved()"
            [showCancel]="showCancelItem(order, item)"
            [showSpinner]="showSpinnerOnItemCancel(item)"
            [isCancelling]="checkCancellingStatusForItem(item)"
            (itemCancel)="onCancelItem(order, item)"
            [validateQuantity]="validateQuantity"
            [showAllStatus]="showAllStatus"
            >
          </app-custom-cart-item>
        </div>
      }
    </div>
  }
</div>
